/** @format */

import {
  useState,
  //  useEffect
} from "react";
import styled from "styled-components";
import DesktopHeader, { MobileHeader } from "../Header";
import Divider from "../Divider";
import ProcessGrid, { MobileProcessGrid } from "../ProcessGrid";
import { BANNER_DATA, SERVICES, TWEETS } from "../../data";
import Lottie from "react-lottie";
import { defaultOptions } from "../../lottie/LottieSettings";
import RequestButton from "../RequestButton";
import Footer from "../Footer";
import ActionMenu from "../Drawer";
// import { motion } from "framer-motion";

import { QUERIES } from "../../constants";
import Hero from "../HeroText";
import ServicesHeader from "../ServicesHeader";
import ProcessHeader from "../ProcessHeader";

// const HEADER_HIDE_THRESHOLD = 400;

function App() {
  const [services, setServices] = useState(SERVICES);
  // const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  // const [mousePosition, setMousePosition] = useState({
  //   x: 0,
  //   y: 0,
  // });
  // const [cursorVariant, setCursorVariant] = useState("default");

  // useEffect(() => {
  //   const mouseMove = (e) => {
  //     setMousePosition({
  //       x: e.clientX,
  //       y: e.clientY,
  //     });
  //   };

  //   window.addEventListener("mousemove", mouseMove);

  //   return () => {
  //     window.removeEventListener("mousemove", mouseMove);
  //   };
  // }, []);

  // const variants = {
  //   default: {
  //     x: mousePosition.x,
  //     y: mousePosition.y,
  //     backgroundColor: "#DF1715",
  //   },
  //   text: {
  //     x: mousePosition.x,
  //     y: mousePosition.y,
  //     backgroundColor: "black",
  //     // mixBlendMode: "difference",
  //   },
  // };

  // const textEnter = () => setCursorVariant("text");
  // const textLeave = () => setCursorVariant("default");

  function handleOpen(serviceId) {
    setServices(
      services.map((service) => {
        if (service.id === serviceId) {
          return {
            ...service,
            open: !service.open,
          };
        } else {
          return service;
        }
      })
    );
  }

  return (
    <div className="App">
      {/* <motion.div
        className="cursor"
        transition={{ ease: "linear" }}
        variants={variants}
        animate={cursorVariant}
      /> */}
      <Wrapper>
        <MobileHeader />
        <SideBar
        // onMouseEnter={textEnter} onMouseLeave={textLeave}
        />
        <ActionMenu
        // mouseEnter={textEnter} mouseLeave={textLeave}
        />
        <GridWrapper>
          <HeroSection>
            <DesktopHeader />
            <Divider />
            <Hero
            // mouseEnter={textEnter} mouseLeave={textLeave}
            />
            <TweetSection>
              <DesktopTweetCardWrapper>
                {TWEETS.map((tweet) => (
                  <TweetCard key={tweet.id}>
                    <TweetText>{tweet.tweet}</TweetText>
                    <TweetTime>{tweet.time}</TweetTime>
                  </TweetCard>
                ))}
                <EmptyPlaceholder />
              </DesktopTweetCardWrapper>
              <MobileTweetCardWrapper>
                {TWEETS.slice(0, 3).map((tweet) => (
                  <TweetCard key={tweet.id}>
                    <TweetText>{tweet.tweet}</TweetText>
                    <TweetTime>{tweet.time}</TweetTime>
                  </TweetCard>
                ))}
              </MobileTweetCardWrapper>
            </TweetSection>
            <StyledLottie>
              <Lottie
                options={defaultOptions}
                width={400}
                height={400}
                style={{ margin: "0px" }}
              />
            </StyledLottie>
          </HeroSection>
          <BannerSectionWrapper>
            <BannerSection>
              <DesktopBannerCardWrapper>
                {BANNER_DATA.map((data) => (
                  <BannerCard key={data.id}>
                    <BannerTextWrapper
                    // onMouseEnter={textEnter}
                    // onMouseLeave={textLeave}
                    >
                      <TitleText>{data.title}</TitleText>
                      <StatText>{data.stat}</StatText>
                      <StatDate>{data.date}</StatDate>
                    </BannerTextWrapper>
                    <BannerImageWrapper>
                      <BannerImage src={data.image} />
                    </BannerImageWrapper>
                  </BannerCard>
                ))}
              </DesktopBannerCardWrapper>
              <MobileBannerCardWrapper>
                {BANNER_DATA.slice(0, 1).map((data) => (
                  <BannerCard key={data.id}>
                    <BannerImage src={data.image} />
                    <BannerTextWrapper>
                      <TitleText>{data.title}</TitleText>
                      <StatText>{data.stat}</StatText>
                      <StatDate>{data.date}</StatDate>
                    </BannerTextWrapper>
                  </BannerCard>
                ))}
              </MobileBannerCardWrapper>
            </BannerSection>
          </BannerSectionWrapper>
          <DarkSection>
            <ProcessSection>
              <ProcessHeader
              // mouseEnter={textEnter} mouseLeave={textLeave}
              />
              <ProcessGrid />
              <MobileProcessGrid />
            </ProcessSection>
            <ServicesSection>
              <ServicesHeader />
              <PaneWrapper>
                {services.map((service) => (
                  <ServicePane key={service.id}>
                    <VisibleRow
                      onClick={() => {
                        handleOpen(service.id);
                      }}
                    >
                      <ServiceTitle isOpen={service.open}>
                        {service.title}
                      </ServiceTitle>
                      <PlusDash isOpen={service.open} />
                    </VisibleRow>
                    <HiddenRow
                      style={{
                        "--panel-height": service.open ? "320px" : "0",
                      }}
                    >
                      <ServiceExtract>{service.extract}</ServiceExtract>
                      <RequestButton blackwhite>
                        Request for stats
                      </RequestButton>
                    </HiddenRow>
                  </ServicePane>
                ))}
              </PaneWrapper>
            </ServicesSection>
            <ValuesSection>
              <ValueCard>
                <ValueImage src="/images/TRANSPARENCY.svg" />
              </ValueCard>
              <ValueCard>
                <ValueImage
                  style={{
                    width: "60%",
                  }}
                  src="/images/FAIRNESS.svg"
                />
              </ValueCard>
              <ValueCard>
                <ValueImage src="/images/Accountability.svg" />
              </ValueCard>
              <ContantUsWrapper>
                <ContactUsButton>Contact Us</ContactUsButton>
              </ContantUsWrapper>
            </ValuesSection>
          </DarkSection>
          <Footer />
        </GridWrapper>
      </Wrapper>
    </div>
  );
}

const SideBar = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: var(--color-primary);
  height: 100%;
  width: 120px;

  @media ${QUERIES.phoneAndSmaller} {
    display: none;
  }
`;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;

const Wrapper = styled.div`
  padding: 10px 122px 0px 0px;

  @media ${QUERIES.phoneAndSmaller} {
    padding: initial;
  }
`;

const HeroSection = styled.section`
  position: relative;
  background: url("/images/Graph2.svg");
  background-size: cover;
  padding-bottom: 60px;
  grid-column: 1 / -1;

  @media ${QUERIES.phoneAndSmaller} {
    background: none;
    padding-bottom: 0px;
  }
`;

const StyledLottie = styled.div`
  position: relative;
  grid-column: 1 / 3;

  @media ${QUERIES.laptopAndSmaller} {
    left: -120px;
    bottom: -230px;
  }
  @media ${QUERIES.tabletAndSmaller} {
    left: -120px;
    bottom: -230px;
  }
  @media ${QUERIES.phoneAndSmaller} {
    left: revert;
    display: none;
  }
`;
const EmptyPlaceholder = styled.div`
  grid-column: 1;
  grid-row: 2;

  @media ${QUERIES.tabletAndSmaller} {
    grid-column: 1;
    grid-row: 3;
  }

  @media ${QUERIES.phoneAndSmaller} {
    display: none;
  }
`;

const TweetSection = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;

const DesktopTweetCardWrapper = styled(TweetSection)`
  display: grid;
  grid-column: 2 / -2;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 40px 120px;
  margin-top: 160px;

  @media ${QUERIES.tabletAndSmaller} {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    gap: 40px 60px;
  }

  @media ${QUERIES.phoneAndSmaller} {
    display: none;
  }
`;

const MobileTweetCardWrapper = styled(DesktopTweetCardWrapper)`
  display: none;

  @media ${QUERIES.phoneAndSmaller} {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    gap: 60px;
    margin-top: 110px;
    margin-bottom: 120px;
  }
`;

const TweetCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
`;

const TweetText = styled.p`
  color: var(--color-dark-500);
`;
const TweetTime = styled.p`
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--color-primary);
`;

const BannerSection = styled.section`
  background-color: var(--color-primary);
`;

const DesktopBannerCardWrapper = styled(DesktopTweetCardWrapper)`
  display: initial;
  overflow-y: scroll;
  scroll-snap-points-y: repeat(100vh);
  scroll-snap-type: y mandatory;

  @media ${QUERIES.phoneAndSmaller} {
    display: none;
  }
`;
const MobileBannerCardWrapper = styled(MobileTweetCardWrapper)`
  display: none;

  @media ${QUERIES.phoneAndSmaller} {
    display: initial;
  }
`;

const BannerSectionWrapper = styled.section`
  grid-column: 1 / -1;
`;

const BannerCard = styled.div`
  display: grid;
  grid-template-columns: 340px 1fr;
  grid-template-rows: repeat(auto-fill, 950px);
  overflow: hidden;
  scroll-snap-align: start;
  position: relative;

  @media ${QUERIES.phoneAndSmaller} {
    grid-template-columns: revert;
    grid-template-rows: 545px 310px;
  }
`;

const BannerTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  height: 100%;
  padding-left: 50px;
  padding-bottom: 120px;

  @media ${QUERIES.phoneAndSmaller} {
    padding-left: 16px;
    padding-bottom: 60px;

    ${BannerCard} &:nth-child(1) {
      grid-column: 1 / -1;
      grid-row: 2 / -1;
    }
  }
`;

const TitleText = styled.h3`
  text-align: left;
  max-width: 14ch;
  color: var(--color-white);
  margin-bottom: 40px;
`;

const StatText = styled.h4`
  font-size: 2.938rem;
  font-weight: 300;
  text-align: left;
  color: var(--color-lavendar);
`;
const StatDate = styled.h5`
  color: var(--color-lavendar);
  text-align: left;
`;

const BannerImageWrapper = styled.div``;

const BannerImage = styled.img`
  height: 100%;
  object-fit: cover;
`;

const DarkSection = styled.div`
  background-color: var(--color-dark-300);
  grid-column: 1 / -1;
`;

const ProcessSection = styled.section`
  background-color: var(--color-dark-300);
  padding: 120px 10px;
`;

const ServicesSection = styled(ProcessSection)`
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  gap: 120px;
`;

const PaneWrapper = styled.div``;

const ServicePane = styled.div`
  --pane-offset: 30px;

  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--color-dark-100);
  padding-top: 30px;

  ${PaneWrapper} &:nth-child(1) {
    border-top: 1px solid var(--color-dark-100);
  }
`;

const VisibleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 32px;

  @media ${QUERIES.phoneAndSmaller} {
    padding-inline: 16px;
  }
`;

const ServiceTitle = styled.h2`
  color: ${({ isOpen }) =>
    isOpen ? `var(--color-offwhite)` : `var(--color-dark-100)`};
  transition: color 350ms ease;
  padding-bottom: var(--pane-offset);
  -webkit-touch-callout: none;
  user-select: none;

  @media ${QUERIES.phoneAndSmaller} {
    max-width: 15ch;
  }
`;

const PlusDash = styled.div`
  position: relative;
  width: 35px;
  height: 4px;
  margin-top: calc(var(--pane-offset) * -1);
  background-color: ${({ isOpen }) =>
    isOpen ? `var(--color-offwhite)` : `var(--color-dark-100)`};
  transition: background-color 350ms ease;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    width: 35px;
    height: 4px;
    background-color: ${({ isOpen }) =>
      isOpen ? `var(--color-offwhite)` : `var(--color-dark-100)`};
    transform: ${({ isOpen }) => (isOpen ? `rotate(90deg)` : `rotate(0deg)`)};
    transition: transform 800ms ease;
  }

  @media ${QUERIES.phoneAndSmaller} {
    transition: transform 350ms ease;
  }
`;

const HiddenRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  max-height: var(--panel-height);
  transition: max-height 850ms ease;
  overflow: hidden;
  padding-inline: 32px;

  @media ${QUERIES.phoneAndSmaller} {
    flex-direction: column;
    gap: 60px;
    align-items: flex-start;
    padding-inline: 16px;
    transition: max-height 350ms ease;
  }
`;

const ServiceExtract = styled.p`
  color: var(--color-white);
  max-width: 65ch;
  padding-bottom: var(--pane-offset);
`;
const ValuesSection = styled(ProcessSection)`
  padding-bottom: 0px;
`;

const ValueCard = styled.div`
  position: sticky;
  margin-top: 150px;
  background-color: var(--color-dark-300);

  ${ValuesSection} &:nth-child(1) {
    top: 25%;
  }
  ${ValuesSection} &:nth-child(2) {
    top: 35%;
  }
  ${ValuesSection} &:nth-child(3) {
    top: 45%;
  }

  @media ${QUERIES.phoneAndSmaller} {
    ${ValuesSection} &:nth-child(1) {
      top: 15%;
    }
    ${ValuesSection} &:nth-child(2) {
      top: 18%;
    }
    ${ValuesSection} &:nth-child(3) {
      top: 21%;
    }
  }
`;

const ValueImage = styled.img``;

const ContantUsWrapper = styled.div`
  padding: 80px 45px;
  position: sticky;
  display: flex;
  justify-content: center;
  background-color: var(--color-dark-300);

  @media ${QUERIES.phoneAndSmaller} {
    padding: 80px 0px;
  }
`;

const ContactUsButton = styled.button`
  text-transform: uppercase;
  color: var(--color-offwhite);
  border: 1px solid var(--color-offwhite);
  border-radius: 100px;
  background-color: transparent;
  padding: 80px 146px;

  @media ${QUERIES.tabletAndSmaller} {
    padding: 40px 73px;
  }

  @media ${QUERIES.phoneAndSmaller} {
    padding: 20px 58px;
    font-size: 0.875rem;
  }
`;

export default App;
